import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const UsageRecordService = {
    list: async () => axios.post(API_URL + "/usageRecords/list").then(( data ) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + `/usageRecords/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    create: async (formData) => axios.post(API_URL + "/usageRecords", formData).then(({ data }) => data).catch((err) => { throw err }),

    update: async (id, formData) => {
        formData.append("_method", "PUT");
        axios.post(API_URL + `/usageRecords/${id}`, formData).then(({ data }) => data).catch((err) => { throw err })
    },

    delete: async (id) => axios.delete(API_URL + `/usageRecords/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    getVehicle: async () => axios.get(API_URL + "/vehicles/options/available").then(({ data }) => data).catch((err) => { throw err }),

    getConductor: async () => axios.get(API_URL + "/effectives/options-without-system").then(({ data }) => data).catch((err) => { throw err }),

    geIdVehicle: async (id) => axios.get(API_URL + `/vehicles/${id}`).then(({ data }) => data).catch((err) => { throw err }),
};

export default UsageRecordService;